module.exports = __webpack_public_path__ + "img/3.46d1aaf2.jpg";